import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({opacity: 0.99,})
      ),
      state('closed', style({opacity: 0,})
      ),
      transition('closed => open', [animate('0.8s 0.1s')]),
      transition('open =>  closed', [animate('0.8s 0.5s ease-out')]), 
    ]),
  ],
})
export class SearchBarComponent {
  @Output() submitted = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<string>();
  @ViewChild('searchBarInput') searchBarInput: ElementRef; 
  @ViewChild('searchBarInput2') searchBarInput2: ElementRef; 
  @ViewChild('searchBarButton') searchBarButton: ElementRef; 

  term = '';
  showModal = false;
  animateModal = false;
  inputHelper: HTMLElement;
  searchBar: HTMLElement;

  constructor(
    private renderer2: Renderer2
  ) { }

  initiateKeyboard() {       
    setTimeout(()=> {      
      this.searchBarInput.nativeElement.focus();     
      this.renderer2.removeChild(this.searchBar, this.inputHelper);
    },180);
  }

  onAnimationEnded(){

  }

  btnClicked() {
    this.showModal = true; 
      this.animateModal = true;

      this.searchBar = this.renderer2.selectRootElement('#searchBar', true);

      // setting helper field and focusing on it
      this.inputHelper = this.renderer2.createElement('input');
      this.renderer2.addClass(this.inputHelper, 'helper-input');
      this.renderer2.appendChild(this.searchBar, this.inputHelper);
      this.inputHelper.focus();

      let event = new KeyboardEvent('touchstart',{'bubbles':true});            
      this.searchBarButton.nativeElement.dispatchEvent(event);
  }

  onFormSubmit(event: any) {
    event.preventDefault();
    this.submitted.emit(this.term);
  }

  clearTerm() {
    console.log('term clear');
    this.term = '';    
    this.cleared.emit(this.term);
  }
}
